import { render, staticRenderFns } from "./BookmakerPromotionEdit.vue?vue&type=template&id=4d93c472&"
import script from "./BookmakerPromotionEdit.vue?vue&type=script&lang=ts&"
export * from "./BookmakerPromotionEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports